import React from "react";
import QnectButton from "../qnect-ui/qnect-button";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "../custom/dialog-title";
import DialogSecondaryTitle from "../custom/dialog-secondary-title";
import Dialog from '../custom/dialog';
import {useDialogStyles} from "../custom/dialog-style";
import {_formatDate, _masked, getGenderLabel, getRelationshipLabel} from "../../utils/utility";
import useConfig from "../../utils/qnect-config";

export const ConfirmChangeDialog = ({open = false, onClose, onOk, policy, ...props}) => {
    const classes = useDialogStyles();
    const cfg = useConfig();

    const getAction = (action) => {
        switch (action) {
            case 'A':
                return cfg('labels.add');
            case 'E':
                return cfg('labels.edit');
            case 'D':
                return cfg('labels.delete');
            default:
                return null;
        }
    }
    function showGstDisclaimer() {
        const currentDate = new Date();
        const gstDisclaimerExpirationDate = new Date("2024-04-01")
            if(gstDisclaimerExpirationDate>=currentDate){
                return true;
            }
        return false;
    }
    return (
        <div className={classes.modal_box_container}>
            <Dialog open={open} onClose={onClose} className={classes.modal_box_container_wide} style={{width: "100%", left: "50%", transform: 'translateX(-50%)'}}>
                <DialogTitle className={classes.title}
                    title={cfg("policyDetailModals.confirmChange.title")}
                    onClose={onClose} lang={props.lang}
                />
                <DialogSecondaryTitle />
                <DialogContent>
                <div className={classes.modal_box_table_container}>
                        <div className='modal_box_table_data_container'>
                            <table cellSpacing="0" cellPadding="0">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Member Id</th>
                                        <th>Relationship</th>
                                        <th>Date Of Birth</th>
                                        <th>Gender</th>
                                        <th>Email Address</th>
                                        <th>NRIC</th>
                                        <th>Subsidiary</th>
                                        <th>Plan No.</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {policy?.members?.map(mem => {
                                        return (
                                            <tr>
                                                <td>{mem.name}</td>
                                                <td>{mem.memberNo}</td>
                                                <td>{getRelationshipLabel(mem.relationship)}</td>
                                                <td>{_formatDate(mem.dateOfBirth)}</td>
                                                <td>{getGenderLabel(mem.gender)}</td>
                                                <td>{mem.emailAddress}</td>
                                                <td>{_masked(mem.securityId)}</td>
                                                <td>{mem.subsidiary}</td>
                                                <td>{mem.plan}</td>
                                                <td>{getAction(mem.action)}</td>
                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                        <div className='confirm_action_container'>
                            <span>{cfg('labels.confirmChange')}</span>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <QnectButton field="cancel" onClick={onClose} />
                    <QnectButton field="confirm" onClick={onOk} />
                </DialogActions>
                {
                    showGstDisclaimer() &&
                    <DialogContent>
                        <div className={classes.modal_box_table_container}>
                            <div className='gst_disclaimer_container'>
                                <span>{cfg('labels.gstDisclaimer')}</span>
                            </div>
                        </div>
                    </DialogContent>
                }
            </Dialog>
        </div>
    );
}

export default ConfirmChangeDialog;


